import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import styled from 'styled-components';
import GameImage from '../components/GameImage';

const CategoryPage = ({ gameData }) => {
  const { categoryName } = useParams();
  const [games, setGames] = useState([]);
  const [visibleGames, setVisibleGames] = useState(12);
  
  useEffect(() => {
    if (gameData && gameData[categoryName]) {
      setGames(gameData[categoryName]);
    }
  }, [gameData, categoryName]);

  const loadMoreGames = () => {
    setVisibleGames(prev => prev + 12);
  };

  return (
    <CategoryContainer>
      <CategoryHeader>
        <CategoryTitle>{categoryName.charAt(0).toUpperCase() + categoryName.slice(1)} Games</CategoryTitle>
        <CategoryDescription>
          Explore our collection of {categoryName} games. Play online for free!
        </CategoryDescription>
      </CategoryHeader>
      
      <GameGrid>
        {games.slice(0, visibleGames).map(game => (
          <GameCard key={game.id}>
            <Link to={`/game/${categoryName}/${game.id}`}>
              <GameImage 
                src={game.thumb300x300} 
                fallbackSrc={game.thumb512x384} 
                alt={game.name} 
                style={{ width: '100%', height: 'auto', display: 'block' }}
              />
              <GameInfo>
                <GameName>{game.name}</GameName>
                <GameTags>{game.tags}</GameTags>
              </GameInfo>
            </Link>
          </GameCard>
        ))}
      </GameGrid>
      
      {visibleGames < games.length && (
        <LoadMoreButton onClick={loadMoreGames}>
          Load More Games
        </LoadMoreButton>
      )}
    </CategoryContainer>
  );
};

const CategoryContainer = styled.div`
  padding: 20px 0;
`;

const CategoryHeader = styled.div`
  margin-bottom: 30px;
  text-align: center;
`;

const CategoryTitle = styled.h1`
  font-size: 32px;
  margin-bottom: 10px;
`;

const CategoryDescription = styled.p`
  color: #666;
  font-size: 16px;
`;

const GameGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 480px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const GameCard = styled.div`
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  a {
    text-decoration: none;
    color: inherit;
  }
`;

// GameThumbnail replaced by GameImage component

const GameInfo = styled.div`
  padding: 15px;
`;

const GameName = styled.h3`
  font-size: 16px;
  margin: 0 0 8px 0;
`;

const GameTags = styled.div`
  font-size: 12px;
  color: #666;
`;

const LoadMoreButton = styled.button`
  background: #45b7d8;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 16px;
  margin: 30px auto;
  display: block;
  cursor: pointer;
  
  &:hover {
    background: #3ca9c9;
  }
`;

export default CategoryPage;
